import React from "react";
import { classNames } from "../../helpers";

export default function TwRadialProgress(props) {
  const { className = "", textClassName = "", progress = 1, percentageText = "", variant = "brown-coffee" } = props
  const radius = 47;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return variant == "brown-coffee" ? (
    <div className={classNames(className, "size-12")}>
      <div className={"relative"}>
        <svg className="w-full [h-full] bg-light-brown-coffee rounded-full" viewBox="0 0 100 100">
          <circle
            // className="text-gray-200 stroke-current"
            className="text-white stroke-current"
            strokeWidth="5"
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
          />
          <circle
            // className="text-blue-500 stroke-current"
            className="text-portland-orange stroke-current"
            strokeWidth="5"
            strokeLinecap="round"
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform="rotate(-90 50 50)" // Rotates the progress to start from the top
            style={{ transition: "stroke-dashoffset 0.5s ease" }}
          />
        </svg>
        <span className={classNames(textClassName, "absolute inset-0 flex items-center justify-center text-sm text-white font-bold")}>
          {Number(progress).toFixed(1)}%
        </span>
      </div>
    </div>
  ) : (variant == "standard-progress" ? (
    <div className={classNames(className, "size-12")}>
      <div className={"relative"}>
        <svg className="w-full [h-full] bg-transparent rounded-full" viewBox="0 0 100 100">
          <circle
            // className="text-gray-200 stroke-current"
            className="text-gray-200 stroke-current"
            strokeWidth="5"
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
          />
          <circle
            // className="text-blue-500 stroke-current"
            className="text-light-brown-coffee stroke-current"
            strokeWidth="5"
            strokeLinecap="round"
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform="rotate(-90 50 50)" // Rotates the progress to start from the top
            style={{ transition: "stroke-dashoffset 0.5s ease" }}
          />
        </svg>
        <span className={classNames(textClassName, "absolute inset-0 flex items-center justify-center text-sm text-light-brown-coffee font-bold")}>
          {Number(progress).toFixed(1)}%
        </span>
      </div>
    </div>
  ) : (
    <div className={classNames(className, "size-12")}>
      <div className={"relative"}>
        <svg className="w-full [h-full] bg-transparent rounded-full" viewBox="0 0 100 100">
          <circle
            // className="text-gray-200 stroke-current"
            className="text-gray-200 stroke-current"
            strokeWidth="15"
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
          />
          <circle
            // className="text-blue-500 stroke-current"
            className="text-portland-orange stroke-current"
            strokeWidth="15"
            strokeLinecap="round"
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform="rotate(-90 50 50)" // Rotates the progress to start from the top
            style={{ transition: "stroke-dashoffset 0.5s ease" }}
          />
        </svg>
        <span className={classNames(textClassName, "absolute inset-0 flex items-center justify-center text-xs text-light-brown-coffee font-bold")}>
          {percentageText}
        </span>
      </div>
    </div>
  ));
}
